import * as Yup from "yup";
import { commonPassword, email } from "../YupSchema";

export interface ISignIn {
  email: string;
  password: string;
  saveLogin: boolean;
  client_ip: string;
  whitelabel_id: number | null;
}

export const validationSignIn = Yup.object().shape({
  email: email,
  password: commonPassword,
  saveLogin: Yup.boolean(),
});
